export default {
  'universal-layout.topmenu.userinfo': '个人信息',
  'universal-layout.topmenu.logout': '退出',

  'universal-layout.menu.home': '首页',
  'universal-layout.menu.home.workplace': '工作台',
  'universal-layout.menu.home.custom-breadcrumbs': '自定义面包屑',
  'universal-layout.menu.home.custom-breadcrumbs.liqingsong.cc': 'liqingsong.cc',
  'universal-layout.menu.home.docs': '使用文档',

  'universal-layout.menu.component': '组件',
  'universal-layout.menu.component.icon': '图标',
  'universal-layout.menu.component.icon.svg': 'IconSvg',
  'universal-layout.menu.component.icon.font': 'IconFont',
  'universal-layout.menu.component.editor': '编辑器',
  'universal-layout.menu.component.editor.tui-editor': 'tui-editor',
  'universal-layout.menu.component.editor.ckeditor': 'CKEditor',

  'universal-layout.menu.pages': '页面示例',
  'universal-layout.menu.pages.list': '列表页面',
  'universal-layout.menu.pages.list.basic': '标准列表',
  'universal-layout.menu.pages.list.table': '表格列表',
  'universal-layout.menu.pages.list.highly-adaptive-table': '高度自适应表格',
  'universal-layout.menu.pages.list.search': '搜索列表',
  'universal-layout.menu.pages.list.search.table': '查询表格',
  'universal-layout.menu.pages.form': '表单页面',
  'universal-layout.menu.pages.form.basic': '基础表单',
  'universal-layout.menu.pages.form.complex': '高级表单',
  'universal-layout.menu.pages.detail': '详情页面',
  'universal-layout.menu.pages.detail.basic': '基础详情',
  'universal-layout.menu.pages.detail.module': '模块详情',
  'universal-layout.menu.pages.detail.table': '表格详情',

  'universal-layout.menu.roles': '权限验证',
  'universal-layout.menu.roles.all': '用户都有权限',
  'universal-layout.menu.roles.user': 'Users有权限',
  'universal-layout.menu.roles.test': 'Tests有权限',
};
